import { Component } from '@angular/core';
import { LandingDesignBase } from '../landing-design-base';

// Diseño 5 de landing: como el diseño 4 pero con cards blancas de borde gris y sin pestañas
// (las secciones van seguidas).
@Component({
  selector: 'app-landing-design-5',
  templateUrl: './landing-design-5.component.html',
  styleUrls: ['./landing-design-5.component.scss'],
})
export class LandingDesign5Component extends LandingDesignBase {}
